export enum AgentAuthType {
  EMAIL = "EMAIL",
  PHONE = "PHONE"
}
